































import 'leaflet/dist/leaflet.css'

import Vue, { PropType } from 'vue'

import { latLng, latLngBounds } from 'leaflet'
import { LMap, LTileLayer, LCircleMarker, LTooltip } from 'vue2-leaflet'

export type Marker<Data = unknown> = {
  location: {
    lat: number
    lng: number
  }
  title: string
  caption?: string
  size: number

  data?: Data
}

export default Vue.extend({
  components: {
    LMap,
    LTileLayer,
    LCircleMarker,
    LTooltip,
  },
  props: {
    markers: {
      type: Array as PropType<Array<Marker>>,
      default: () => [],
    },
    current: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      zoom: 6,
      center: [0, 0],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5,
      },
      showMap: true,

      markerIconSize: 48,
    }
  },
  computed: {
    bounds() {
      if (this.markers.length === 0) return null
      return latLngBounds([
        [
          Math.min(...this.markers.map(m => m.location.lat)),
          Math.min(...this.markers.map(m => m.location.lng)),
        ],
        [
          Math.max(...this.markers.map(m => m.location.lat)),
          Math.max(...this.markers.map(m => m.location.lng)),
        ],
      ])
    },
  },
  methods: {
    getLatLng(loc: { lat: number; lng: number }) {
      return latLng(loc.lat, loc.lng)
    },
    markerClick(e: Marker) {
      this.$emit('click:marker', e)
    },
    updateCurrent(i: number | null) {
      this.$emit('update:current', i)
    },
  },
})
